// extracted by mini-css-extract-plugin
export var bottomCloud = "TextAndImagesModule-module--bottomCloud--14905";
export var buttonsContainer = "TextAndImagesModule-module--buttonsContainer--41bdd";
export var container = "TextAndImagesModule-module--container--f6a11";
export var contentContainer = "TextAndImagesModule-module--contentContainer--d3411";
export var desktop = "TextAndImagesModule-module--desktop--6fd26";
export var featuredIllustration = "TextAndImagesModule-module--featuredIllustration--21351";
export var illustrationContainer = "TextAndImagesModule-module--illustrationContainer--186da";
export var image0 = "TextAndImagesModule-module--image-0--e032e";
export var image1 = "TextAndImagesModule-module--image-1--6eb3b";
export var image2 = "TextAndImagesModule-module--image-2--6d16b";
export var image3 = "TextAndImagesModule-module--image-3--3295a";
export var imageContainer = "TextAndImagesModule-module--imageContainer--d64ec";
export var largeImageContainer = "TextAndImagesModule-module--largeImageContainer--2c13d";
export var mediaContainer = "TextAndImagesModule-module--mediaContainer--03cc7";
export var mediaOnTheRight = "TextAndImagesModule-module--mediaOnTheRight--b3837";
export var mobile = "TextAndImagesModule-module--mobile--bc48f";
export var smallImageContainer = "TextAndImagesModule-module--smallImageContainer--0467b";
export var text = "TextAndImagesModule-module--text--0fae1";
export var textContainer = "TextAndImagesModule-module--textContainer--163ed";
export var title = "TextAndImagesModule-module--title--c2ac2";
export var topCloud = "TextAndImagesModule-module--topCloud--00448";
export var withLargerFirstImage = "TextAndImagesModule-module--withLargerFirstImage--86dc1";